(function () {
  function eckoTrack(eventName, params = {}) {
    let didTrack = false;
    const category = 'Ecko';
    const name = ['title', 'provider', 'reason']
      .filter(key => params[key])
      .map(key => `${key}:${params[key]}`)
      .join(', ');
    const value = Number.isFinite(params.count) ? params.count : undefined;

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
      didTrack = true;
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ...params });
      didTrack = true;
    }
    if (typeof window._paq === 'object') {
      const eventNameMap = {
        ecko_yeargroup_filter_change: "Filter update",
        ecko_event_add_to_calendar_open: "Add to calendar opened",
        ecko_event_add_to_calendar_provider: "Add to calendar provider selected",
        ecko_subscribe_calendar_modal_open: "Subscribe to calendar opened",
        ecko_subscribe_calendar_provider: "Subscribe to calendar provider selected",
        ecko_story_dismiss: "Story dismissed",
        ecko_story_undo_dismiss: "Story dismissal undone"
      };

      const prettyEventName = eventNameMap[eventName] || eventName;
      // console.log('[Ecko analytics] Matomo event tracked:', prettyEventName, params);
      window._paq.push(['trackEvent', category, prettyEventName, name || undefined, value]);
      didTrack = true;
    }
    // if (!didTrack) {
    //   console.log('[Ecko analytics]', eventName, params);
    // }
  }

  window.addEventListener('ecko:yeargroupFilterChange', e => {
    const { reason, enabledSlugs } = e.detail;
    eckoTrack('ecko_yeargroup_filter_change', {
      reason,
      count: enabledSlugs.length
    });
  });

  window.addEventListener('ecko:eventAddToCalendarOpen', e => {
    eckoTrack('ecko_event_add_to_calendar_open', {
      title: e.detail.title
    });
  });

  window.addEventListener('ecko:eventAddToCalendarProvider', e => {
    eckoTrack('ecko_event_add_to_calendar_provider', {
      provider: e.detail.provider,
      title: e.detail.title
    });
  });

  window.addEventListener('ecko:subscribeCalendarModalOpen', () => {
    eckoTrack('ecko_subscribe_calendar_modal_open');
  });

  window.addEventListener('ecko:subscribeCalendarProvider', e => {
    eckoTrack('ecko_subscribe_calendar_provider', {
      provider: e.detail.provider
    });
  });

  window.addEventListener('ecko:storyDismiss', e => {
    eckoTrack('ecko_story_dismiss', {
      story_id: e.detail.storyId
    });
  });

  window.addEventListener('ecko:storyUndoDismiss', e => {
    eckoTrack('ecko_story_undo_dismiss', {
      story_id: e.detail.storyId
    });
  });
})();
